export type Language = 'en' | 'hi'

export const translations = {
  en: {
    // Top Ribbon
    ribbon_delivery_speed: 'Delivery in 15–25 mins',
    ribbon_free_delivery: 'Free delivery on orders over ₹499',
    ribbon_guarantee: '100% Quality & Freshness Guarantee',

    // Header & Navigation
    brand_superfast: 'Superfast Delivery',
    nav_deliver_in: 'Deliver in 15 mins',
    nav_pincode: 'Pincode',
    nav_search_placeholder: 'Search for atta, dal, milk, fresh mangoes...',
    nav_orders: 'Orders',
    nav_basket: 'Basket',
    nav_items_count: '{count} items',
    nav_sign_in: 'Sign in',
    nav_sign_out: 'Sign out',
    nav_edit_profile: 'Edit Profile',
    nav_my_orders: 'My Orders & Receipts',
    nav_addresses: 'Delivery Addresses',
    nav_verified_customer: 'Phone Verified Customer',

    // Language
    lang_select: 'Language',
    lang_en: 'English',
    lang_hi: 'हिंदी',

    // Profile Modal
    profile_title: 'Your Account Details',
    profile_mobile: 'Registered Mobile',
    profile_mobile_note: 'Phone numbers are verified via OTP.',
    profile_fullname: 'Full Name',
    profile_fullname_placeholder: 'e.g. Rahul Sharma',
    profile_email: 'Email Address',
    profile_email_placeholder: 'name@example.com',
    profile_email_note: 'Invoices and delivery updates will be sent here.',
    profile_cancel: 'Cancel',
    profile_save: 'Save Changes',
    profile_saving: 'Saving…',
    profile_saved: 'Profile updated successfully!',

    // Pincode Modal
    pincode_title: 'Check Delivery Pincode',
    pincode_desc: 'Enter your 6-digit delivery pincode to confirm express 15-minute delivery eligibility.',
    pincode_label: 'Pincode',
    pincode_btn_check: 'Check Serviceability',
    pincode_btn_checking: 'Checking…',
    pincode_available: 'Available! Delivery in 15–25 mins to {area}.',
    pincode_outside: 'Sorry, this pincode is currently outside our delivery zone.',
    pincode_standard: 'Delivery available in standard zones (15-25 mins).',

    // Catalog & Categories
    cat_all: 'All Categories',
    cat_vegetables: 'Vegetables',
    cat_fruits: 'Fruits',
    cat_dairy: 'Dairy & Milk',
    cat_bakery: 'Bakery & Bread',
    cat_staples: 'Atta & Staples',
    cat_snacks: 'Snacks & Munchies',
    cat_beverages: 'Drinks & Juices',
    cat_organic: 'Organic & Fresh',
    cat_spices: 'Spices & Masalas',
    cat_meat: 'Meat & Eggs',

    search_showing_for: 'Showing results for',
    search_clear: 'Clear',
    search_no_results: 'No products found',
    search_no_results_desc: 'Try checking your spelling or searching for a more general grocery item.',
    search_reset: 'View All Groceries',

    product_direct_farm: 'Direct from farm',
    product_in_stock: 'In Stock',
    product_out_of_stock: 'Out of Stock',
    product_add: 'Add',
    product_added: 'Added',
    product_save: 'Save',
    product_load_more: 'Load More Groceries',
    product_loading_more: 'Loading more…',
    product_all_loaded: 'You have viewed all products in this category',

    // Product Detail
    detail_back: 'Back to Groceries',
    detail_not_found: 'Product not found',
    detail_special_price: 'Special Price',
    detail_mrp: 'MRP',
    detail_save_badge: 'Save {amount} ({percent}% OFF)',
    detail_qty_select: 'Select Quantity / Pack Size',
    detail_add_btn: 'Add to Basket',
    detail_adding: 'Adding to Basket…',
    detail_added: 'Added to Basket!',
    detail_out_of_stock_btn: 'Currently Out of Stock',
    detail_highlights: 'Product Highlights',
    detail_express_badge: 'Superfast 15–25 mins delivery to your doorstep',
    detail_quality_badge: 'Guaranteed farm freshness & highest standard quality',
    detail_fssai_badge: '100% hygienic handling & contactless packaging',
    detail_specs: 'Specifications',
    detail_unit: 'Unit / Weight',
    detail_shelf_life: 'Shelf Life',
    detail_days: '{days} days',
    detail_description: 'About the Product',

    // Cart
    cart_title: 'Shopping Basket',
    cart_items_count: '{count} item in your cart',
    cart_items_count_plural: '{count} items in your cart',
    cart_continue_shopping: 'Continue Shopping',
    cart_empty_title: 'Your basket is empty',
    cart_empty_desc: "Looks like you haven't added anything to your cart yet. Explore our farm-fresh produce and daily grocery items.",
    cart_start_shopping: 'Start Shopping',
    cart_free_delivery_unlocked: '🎉 Congratulations! You have unlocked FREE Express Delivery!',
    cart_free_delivery_add_more: 'Add {amount} more for FREE Delivery!',
    cart_unavailable_notice: 'Some items in your cart are currently unavailable and have been marked for review.',
    cart_remove: 'Remove',
    cart_coupon_title: 'Have a coupon code?',
    cart_coupon_placeholder: 'Enter promo code',
    cart_coupon_apply: 'Apply',
    cart_coupon_applied: 'Coupon applied',
    cart_coupon_remove: 'Remove coupon',
    cart_bill_details: 'Bill Details',
    cart_item_total: 'Item Total',
    cart_delivery_partner_fee: 'Delivery Partner Fee',
    cart_delivery_free: 'FREE',
    cart_taxes_charges: 'Handling & Govt Taxes',
    cart_discount: 'Coupon Savings',
    cart_to_pay: 'To Pay',
    cart_proceed_to_checkout: 'Proceed to Checkout',
    cart_secure_checkout: '100% Safe & Encrypted Checkout',

    // Checkout
    checkout_title: 'Checkout',
    checkout_order_summary: 'Order Summary',
    checkout_delivery_type: 'Fulfilment Method',
    checkout_home_delivery: 'Home Delivery',
    checkout_store_pickup: 'Store Pickup',
    checkout_address_title: 'Delivery Address',
    checkout_address_select: 'Select where to deliver',
    checkout_address_add_new: '+ Add New Address',
    checkout_address_default: 'Default',
    checkout_slot_title: 'Delivery Slot',
    checkout_slot_select: 'Choose a delivery time',
    checkout_slot_full: 'Full',
    checkout_slot_closed: 'Closed',
    checkout_payment_title: 'Payment Method',
    checkout_payment_online: 'Pay Online (UPI / Cards / NetBanking)',
    checkout_payment_online_desc: 'Pay securely via UPI (Google Pay, PhonePe, Paytm) or Cards. Instant refund on returns.',
    checkout_payment_cod: 'Cash on Delivery (COD)',
    checkout_payment_cod_desc: 'Pay cash or UPI upon delivery at your doorstep.',
    checkout_place_order: 'Place Order',
    checkout_placing: 'Placing your order…',
    checkout_security_badge: '256-bit Bank Grade Secure Checkout',
    checkout_empty_cart_msg: 'Your basket is empty. Please add items before checking out.',

    // Address Modal
    addr_modal_title: 'Add New Delivery Address',
    addr_recipient: 'Recipient Name',
    addr_phone: 'Contact Phone Number',
    addr_line1: 'Flat / House No. / Building / Street',
    addr_line2: 'Area / Colony / Landmark',
    addr_city: 'City',
    addr_state: 'State',
    addr_pincode: 'Pincode (6 digits)',
    addr_save_btn: 'Save & Use This Address',
    addr_saving: 'Saving Address…',
    addr_cancel: 'Cancel',

    // Orders List
    orders_title: 'Your Orders',
    orders_auth_title: 'Your Orders',
    orders_auth_desc: 'Sign in to view your order history, live order tracking, and downloadable GST invoices.',
    orders_auth_btn: 'Sign In to View Orders',
    orders_loading: 'Loading your orders…',
    orders_empty_title: 'No Orders Yet',
    orders_empty_desc: "You haven't placed any orders yet. Fresh organic groceries and daily staples are waiting for you!",
    orders_start_btn: 'Start Shopping',
    orders_order_number: 'Order #{num}',
    orders_placed_on: 'Placed on',
    orders_items: 'Items',
    orders_total: 'Total',
    orders_view_details: 'View Details',
    orders_track: 'Track Order',
    orders_load_more: 'Load More Orders',

    // Order Detail
    order_detail_title: 'Order Details',
    order_detail_back: 'Back to all orders',
    order_detail_status_placed: 'Order Placed',
    order_detail_status_confirmed: 'Confirmed',
    order_detail_status_packing: 'Packing Items',
    order_detail_status_ready: 'Ready for Pickup',
    order_detail_status_out_for_delivery: 'Out for Delivery',
    order_detail_status_delivered: 'Delivered',
    order_detail_status_cancelled: 'Cancelled',
    order_detail_track_title: 'Live Tracking & Status',
    order_detail_items_title: 'Items in this Order',
    order_detail_address_title: 'Delivery Address',
    order_detail_payment_title: 'Payment & Billing',
    order_detail_invoice: 'Download GST Invoice',
    order_detail_cancel_btn: 'Cancel Order',
    order_detail_cancel_confirm: 'Are you sure you want to cancel this order?',
    order_detail_cancelled_msg: 'This order has been cancelled.',

    // Order Success Modal
    modal_success_badge: 'Order Placed Successfully! 🎉',
    modal_success_title: 'Order Confirmed!',
    modal_success_subtitle: 'Your order will be confirmed and will deliver soon!',
    modal_success_hinglish_reassurance: 'Aapka order confirm ho gaya hai aur jaldi hi aapke address par deliver hoga 🚀',
    modal_packing_started: 'Packing Started · Out for Delivery Soon',
    modal_pickup_ready: 'Store Pickup Confirmed',
    modal_slot_label: 'Slot',
    modal_delivering_to: 'Delivering to',
    modal_payment_cod: 'Cash on Delivery (COD)',
    modal_payment_online: 'Paid Online via Razorpay',
    modal_zero_cash: 'Zero cash required upon delivery · Contactless drop available',
    modal_verified: '✓ Verified',
    modal_track_order_btn: 'Track Live Order',
    modal_continue_shopping_btn: 'Continue Shopping',
    modal_order_num_copied: 'Copied!',
    modal_auto_redirect: 'Redirecting to live tracker in {sec}s…',

    // Sign In / Auth
    auth_welcome_title: 'Sign In / Register',
    auth_welcome_subtitle: 'Order fresh groceries in minutes with zero hassle',
    auth_mode_password: 'Password Sign In',
    auth_mode_otp: 'OTP Sign In',
    auth_mode_register: 'Create New Account',
    auth_mode_forgot: 'Reset Password',
    auth_phone_label: 'Mobile Phone Number',
    auth_phone_placeholder: '10-digit mobile number',
    auth_password_label: 'Password',
    auth_password_placeholder: 'Enter your password',
    auth_confirm_password_label: 'Confirm Password',
    auth_confirm_password_placeholder: 'Re-enter your password',
    auth_fullname_label: 'Your Name',
    auth_fullname_placeholder: 'Enter full name (e.g. Amit Kumar)',
    auth_otp_label: 'Enter 4-Digit OTP',
    auth_otp_sent_to: 'We sent a verification code to {phone}',
    auth_send_otp_btn: 'Send Verification Code',
    auth_verify_btn: 'Verify & Sign In',
    auth_login_btn: 'Sign In',
    auth_register_btn: 'Create Account & Continue',
    auth_reset_btn: 'Reset Password',
    auth_resend_otp: 'Resend OTP',
    auth_resend_in: 'Resend code in {sec}s',
    auth_forgot_link: 'Forgot password?',
    auth_back_to_login: 'Back to Sign In',
    auth_new_user: 'New to FreshGrocer?',
    auth_already_account: 'Already have an account?',
    auth_terms_note: 'By continuing, you agree to our Terms of Service & Privacy Policy.',

    // Footer
    footer_about: 'Superfast fresh groceries, farm-fresh produce, and pantry staples delivered to your doorstep in 15–25 minutes.',
    footer_hours: '7:00 AM – 11:00 PM Daily',
    footer_categories_title: 'Shop Categories',
    footer_customer_care: 'Customer Care',
    footer_safe_certified: 'Safe & Certified',
    footer_cat_veg_fruit: 'Fresh Vegetables & Fruits',
    footer_cat_dairy: 'Dairy, Bread & Eggs',
    footer_cat_staples: 'Atta, Rice & Staples',
    footer_cat_snacks: 'Snacks & Instant Food',
    footer_care_track: 'Track Order & Receipts',
    footer_care_delivery: 'Delivery Information',
    footer_care_returns: 'Easy 2-Hour Returns',
    footer_care_support: 'Support: care@freshgrocer.com',
    footer_cert_fssai: 'FSSAI Certified Dark Stores',
    footer_cert_sanitized: 'Contactless & Sanitized Delivery',
    footer_cert_gst: 'Authoritative GST Invoices',
    footer_copyright: '© {year} FreshGrocer Platform Ltd. All prices are GST inclusive.',
    footer_payments_accepted: 'Razorpay Verified • UPI & Cards Accepted • Cash on Delivery',

    // Checkout extra
    checkout_signin_title: 'Sign in to Checkout',
    checkout_signin_desc: 'Please sign in with your mobile number to view saved delivery addresses, choose time slots, and track your fresh grocery delivery.',
    checkout_signin_btn: 'Sign In to Continue',
    checkout_step_how: 'How would you like your order?',
    checkout_home_delivery_desc: 'Delivered to door in 15–25 mins',
    checkout_store_pickup_desc: 'Collect ready bags from store',
    checkout_no_address: 'No saved address yet',
    checkout_no_address_desc: 'Add an address to enable express delivery',
    checkout_add_address_now: '+ Add Address Now',
    checkout_slot_step: 'Delivery Time Slot',
    checkout_slot_date: 'Delivery Date',
    checkout_slot_auto: 'Standard express slots (15–25 mins) will be automatically assigned.',
    checkout_payment_step: 'Payment Option',
    checkout_online_subtitle: 'Instant Razorpay gateway with zero surcharge',
    checkout_cod_subtitle: 'Pay cash or UPI scan directly at doorstep',
    checkout_otp_badge: 'Requires 4-digit code confirmation at delivery handover.',
    checkout_goods_subtotal: 'Goods Subtotal',
    checkout_coupon: 'Coupon',
    checkout_delivery_fee: 'Delivery Fee',
    checkout_gst_included: 'GST Included',
    checkout_grand_total: 'Grand Total',
    checkout_guaranteed_price: 'Guaranteed final checkout price',
    checkout_calculating: 'Calculating exact tax and delivery quote…',
    checkout_badge_secure: 'Razorpay Verified & GST Tax Invoice Included',

    // Order Detail extra
    order_banner_title: 'Your order will be confirmed and will deliver soon!',
    order_banner_desc: 'Aapka order confirm ho gaya hai aur jaldi hi aapke doorstep par deliver hoga. Niche real-time status track karein.',
    order_banner_badge: 'Order Confirmed',
    order_banner_packing: '⚡ Packing started',
    order_items_ordered: 'Items Ordered ({count})',
    order_delivering_to: 'Delivering To',
    order_tracking_timeline: 'Tracking Timeline',
    order_payment_breakdown: 'Payment Breakdown',
    order_goods_subtotal: 'Goods Subtotal',
    order_prod_discounts: 'Product Discounts',
    order_delivery_fee: 'Delivery Fee',
    order_gst_included: 'GST Included in Items',
    order_total_amount: 'Total Amount',
    order_amount_paid: 'Amount Paid',
    order_weighed_notice: 'Items weighed at packing: The final quantities and charge have been adjusted based on actual produce weight.',
    order_cancel_title: 'Cancel Order',
    order_cancel_desc: 'You can cancel this order while it is in the received stage.',
    order_cancel_reason_ph: 'Cancellation reason (optional)',
    order_cancelling: 'Cancelling…',
    order_pay_now_razorpay: 'Pay {amount} via Razorpay',
    order_pay_cash_instead: 'Pay via Cash on Delivery instead',
    order_prefer_cashless: 'Prefer cashless? Pay Online via Razorpay',
    order_payment_pending: 'Online Payment Pending',
    order_payment_due_badge: 'Payment Due',
    order_pay_at_delivery_badge: 'Pay at Delivery',
    order_opening_razorpay: 'Opening Razorpay…',
    order_switching_cash: 'Switching to Cash…',
    order_cod_due_notice: 'Your order is set to Cash on Delivery. Please keep cash ready when our partner arrives.',
  },

  hi: {
    // Top Ribbon
    ribbon_delivery_speed: '15–25 मिनट में सुपरफास्ट डिलीवरी',
    ribbon_free_delivery: '₹499 से अधिक के ऑर्डर पर मुफ़्त डिलीवरी',
    ribbon_guarantee: '100% शुद्धता और ताज़गी की गारंटी',

    // Header & Navigation
    brand_superfast: 'सुपरफास्ट डिलीवरी',
    nav_deliver_in: '15 मिनट में डिलीवरी',
    nav_pincode: 'पिनकोड',
    nav_search_placeholder: 'आटा, दाल, दूध, ताज़े फल व सब्ज़ियां खोजें...',
    nav_orders: 'ऑर्डर्स',
    nav_basket: 'टोकरी',
    nav_items_count: '{count} सामान',
    nav_sign_in: 'साइन इन करें',
    nav_sign_out: 'लॉग आउट',
    nav_edit_profile: 'प्रोफ़ाइल बदलें',
    nav_my_orders: 'मेरे ऑर्डर्स और रसीदें',
    nav_addresses: 'डिलीवरी के पते',
    nav_verified_customer: 'सत्यापित ग्राहक',

    // Language
    lang_select: 'भाषा चुनें',
    lang_en: 'English',
    lang_hi: 'हिंदी',

    // Profile Modal
    profile_title: 'आपके खाते का विवरण',
    profile_mobile: 'पंजीकृत मोबाइल नंबर',
    profile_mobile_note: 'मोबाइल नंबर OTP द्वारा सत्यापित हैं।',
    profile_fullname: 'पूरा नाम',
    profile_fullname_placeholder: 'उदा. राहुल शर्मा',
    profile_email: 'ईमेल पता',
    profile_email_placeholder: 'name@example.com',
    profile_email_note: 'बिल और डिलीवरी की जानकारी इस ईमेल पर भेजी जाएगी।',
    profile_cancel: 'रद्द करें',
    profile_save: 'बदलाव सहेजें',
    profile_saving: 'सहेजा जा रहा है…',
    profile_saved: 'प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई!',

    // Pincode Modal
    pincode_title: 'डिलीवरी पिनकोड जांचें',
    pincode_desc: '15 मिनट की एक्सप्रेस डिलीवरी की जांच के लिए अपना 6 अंकों का पिनकोड दर्ज करें।',
    pincode_label: 'पिनकोड',
    pincode_btn_check: 'उपलब्धता जांचें',
    pincode_btn_checking: 'जांच जारी है…',
    pincode_available: 'उपलब्ध है! {area} पर 15–25 मिनट में डिलीवरी होगी।',
    pincode_outside: 'क्षमा करें, यह पिनकोड अभी हमारे डिलीवरी क्षेत्र से बाहर है।',
    pincode_standard: 'मानक क्षेत्रों में डिलीवरी उपलब्ध है (15-25 मिनट)।',

    // Catalog & Categories
    cat_all: 'सभी श्रेणियां',
    cat_vegetables: 'ताज़ी सब्जियां',
    cat_fruits: 'ताज़े फल',
    cat_dairy: 'दूध, दही और मक्खन',
    cat_bakery: 'ब्रेड और बेकरी',
    cat_staples: 'आटा, चावल और दालें',
    cat_snacks: 'नमकीन और स्नैक्स',
    cat_beverages: 'कोल्ड ड्रिंक और जूस',
    cat_organic: 'ऑर्गेनिक उत्पाद',
    cat_spices: 'मसाले और तेल',
    cat_meat: 'अंडे और मांस',

    search_showing_for: 'खोज परिणाम:',
    search_clear: 'हटाएं',
    search_no_results: 'कोई सामान नहीं मिला',
    search_no_results_desc: 'कृपया सही स्पेलिंग जांचें या कोई अन्य सामान्य ग्रॉसरी नाम खोजें।',
    search_reset: 'सभी उत्पाद देखें',

    product_direct_farm: 'खेतों से सीधा ताज़ा',
    product_in_stock: 'स्टॉक में उपलब्ध',
    product_out_of_stock: 'स्टॉक खत्म हो गया है',
    product_add: 'जोड़ें',
    product_added: 'जुड़ गया',
    product_save: 'बचत',
    product_load_more: 'और सामान देखें',
    product_loading_more: 'लोड हो रहा है…',
    product_all_loaded: 'इस श्रेणी के सभी सामान लोड हो चुके हैं',

    // Product Detail
    detail_back: 'ग्रॉसरी पर वापस जाएं',
    detail_not_found: 'उत्पाद नहीं मिला',
    detail_special_price: 'विशेष मूल्य',
    detail_mrp: 'एमआरपी (MRP)',
    detail_save_badge: '{amount} की बचत ({percent}% छूट)',
    detail_qty_select: 'मात्रा / पैक साइज़ चुनें',
    detail_add_btn: 'टोकरी में जोड़ें',
    detail_adding: 'जोड़ा जा रहा है…',
    detail_added: 'टोकरी में जोड़ दिया गया!',
    detail_out_of_stock_btn: 'फिलहाल स्टॉक में नहीं है',
    detail_highlights: 'उत्पाद की मुख्य विशेषताएं',
    detail_express_badge: '15–25 मिनट में आपके घर तक सुपरफास्ट डिलीवरी',
    detail_quality_badge: 'खेतों की ताज़गी और बेहतरीन गुणवत्ता की गारंटी',
    detail_fssai_badge: '100% स्वच्छ पैकेजिंग और सुरक्षित डिलीवरी',
    detail_specs: 'विवरण',
    detail_unit: 'इकाई / वज़न',
    detail_shelf_life: 'शेल्फ लाइफ',
    detail_days: '{days} दिन',
    detail_description: 'उत्पाद के बारे में',

    // Cart
    cart_title: 'आपकी शॉपिंग टोकरी',
    cart_items_count: 'आपकी टोकरी में {count} सामान है',
    cart_items_count_plural: 'आपकी टोकरी में {count} सामान हैं',
    cart_continue_shopping: 'शॉपिंग जारी रखें',
    cart_empty_title: 'आपकी टोकरी खाली है',
    cart_empty_desc: 'लगता है आपने अभी तक कोई सामान नहीं जोड़ा है। हमारी ताज़ी सब्जियां और दैनिक ग्रॉसरी देखें।',
    cart_start_shopping: 'खरीदारी शुरू करें',
    cart_free_delivery_unlocked: '🎉 बधाई हो! आपको मुफ़्त एक्सप्रेस डिलीवरी मिल गई है!',
    cart_free_delivery_add_more: 'मुफ़्त डिलीवरी के लिए {amount} का सामान और जोड़ें!',
    cart_unavailable_notice: 'आपकी टोकरी के कुछ सामान फिलहाल अनुपलब्ध हैं। कृपया जांचें।',
    cart_remove: 'हटाएं',
    cart_coupon_title: 'कूपन कोड है?',
    cart_coupon_placeholder: 'प्रोमो कोड दर्ज करें',
    cart_coupon_apply: 'लागू करें',
    cart_coupon_applied: 'कूपन लागू हो गया',
    cart_coupon_remove: 'कूपन हटाएं',
    cart_bill_details: 'बिल का विवरण',
    cart_item_total: 'सामान का कुल मूल्य',
    cart_delivery_partner_fee: 'डिलीवरी शुल्क',
    cart_delivery_free: 'मुफ़्त',
    cart_taxes_charges: 'हैंडलिंग और सरकारी टैक्स',
    cart_discount: 'कूपन से बचत',
    cart_to_pay: 'कुल भुगतान राशि',
    cart_proceed_to_checkout: 'चेकआउट के लिए आगे बढ़ें',
    cart_secure_checkout: '100% सुरक्षित और एन्क्रिप्टेड भुगतान',

    // Checkout
    checkout_title: 'चेकआउट',
    checkout_order_summary: 'ऑर्डर सारांश',
    checkout_delivery_type: 'डिलीवरी का प्रकार',
    checkout_home_delivery: 'घर पर डिलीवरी',
    checkout_store_pickup: 'दुकान से पिकअप',
    checkout_address_title: 'डिलीवरी का पता',
    checkout_address_select: 'डिलीवरी का पता चुनें',
    checkout_address_add_new: '+ नया पता जोड़ें',
    checkout_address_default: 'प्राथमिक',
    checkout_slot_title: 'डिलीवरी का समय (स्लॉट)',
    checkout_slot_select: 'पसंदीदा समय चुनें',
    checkout_slot_full: 'फुल',
    checkout_slot_closed: 'बंद',
    checkout_payment_title: 'भुगतान का तरीका',
    checkout_payment_online: 'ऑनलाइन भुगतान (UPI / कार्ड / नेटबैंकिंग)',
    checkout_payment_online_desc: 'UPI (Google Pay, PhonePe, Paytm) या कार्ड से सुरक्षित भुगतान। तुरंत रिफंड गारंटी।',
    checkout_payment_cod: 'कैश ऑन डिलीवरी (COD)',
    checkout_payment_cod_desc: 'डिलीवरी मिलने पर नकद या UPI द्वारा भुगतान करें।',
    checkout_place_order: 'ऑर्डर दें',
    checkout_placing: 'ऑर्डर सबमिट हो रहा है…',
    checkout_security_badge: '256-बिट बैंक स्तरीय सुरक्षित चेकआउट',
    checkout_empty_cart_msg: 'आपकी टोकरी खाली है। कृपया चेकआउट से पहले सामान जोड़ें।',

    // Address Modal
    addr_modal_title: 'नया डिलीवरी पता जोड़ें',
    addr_recipient: 'प्राप्तकर्ता का नाम',
    addr_phone: 'संपर्क मोबाइल नंबर',
    addr_line1: 'मकान / फ्लैट नं., गली या भवन',
    addr_line2: 'इलाका / कॉलोनी / लैंडमार्क',
    addr_city: 'शहर',
    addr_state: 'राज्य',
    addr_pincode: 'पिनकोड (6 अंक)',
    addr_save_btn: 'सहेजें और इस पते का उपयोग करें',
    addr_saving: 'सहेजा जा रहा है…',
    addr_cancel: 'रद्द करें',

    // Orders List
    orders_title: 'आपके ऑर्डर्स',
    orders_auth_title: 'आपके पिछले ऑर्डर्स',
    orders_auth_desc: 'ऑर्डर हिस्ट्री, लाइव ट्रैकिंग और GST इनवॉइस देखने के लिए साइन इन करें।',
    orders_auth_btn: 'ऑर्डर्स देखने के लिए साइन इन करें',
    orders_loading: 'ऑर्डर्स लोड हो रहे हैं…',
    orders_empty_title: 'अभी तक कोई ऑर्डर नहीं है',
    orders_empty_desc: 'आपने अभी तक कोई ऑर्डर नहीं दिया है। ताज़ा ग्रॉसरी और राशन आपका इंतज़ार कर रहे हैं!',
    orders_start_btn: 'शॉपिंग शुरू करें',
    orders_order_number: 'ऑर्डर #{num}',
    orders_placed_on: 'ऑर्डर की तारीख:',
    orders_items: 'सामान',
    orders_total: 'कुल राशि',
    orders_view_details: 'विवरण देखें',
    orders_track: 'ट्रैक करें',
    orders_load_more: 'और ऑर्डर्स देखें',

    // Order Detail
    order_detail_title: 'ऑर्डर विवरण',
    order_detail_back: 'सभी ऑर्डर्स पर वापस जाएं',
    order_detail_status_placed: 'ऑर्डर प्राप्त हुआ',
    order_detail_status_confirmed: 'कन्फर्म हुआ',
    order_detail_status_packing: 'पैक हो रहा है',
    order_detail_status_ready: 'पिकअप के लिए तैयार',
    order_detail_status_out_for_delivery: 'डिलीवरी के लिए निकल गया',
    order_detail_status_delivered: 'सफलतापूर्वक डिलीवर हो गया',
    order_detail_status_cancelled: 'रद्द कर दिया गया',
    order_detail_track_title: 'लाइव ट्रैकिंग व स्थिति',
    order_detail_items_title: 'ऑर्डर का सामान',
    order_detail_address_title: 'डिलीवरी का पता',
    order_detail_payment_title: 'भुगतान और बिल',
    order_detail_invoice: 'GST इनवॉइस डाउनलोड करें',
    order_detail_cancel_btn: 'ऑर्डर रद्द करें',
    order_detail_cancel_confirm: 'क्या आप वाकई यह ऑर्डर रद्द करना चाहते हैं?',
    order_detail_cancelled_msg: 'यह ऑर्डर रद्द किया जा चुका है।',

    // Order Success Modal
    modal_success_badge: 'ऑर्डर सफलतापूर्वक प्राप्त हुआ! 🎉',
    modal_success_title: 'ऑर्डर कन्फर्म हो गया!',
    modal_success_subtitle: 'आपका ऑर्डर कन्फर्म हो गया है और जल्द ही डिलीवर होगा!',
    modal_success_hinglish_reassurance: 'Aapka order confirm ho gaya hai aur jaldi hi aapke address par deliver hoga 🚀',
    modal_packing_started: 'पैकिंग शुरू हो गई है · जल्द ही डिलीवरी के लिए निकलेगा',
    modal_pickup_ready: 'स्टोर पिकअप कन्फर्म हुआ',
    modal_slot_label: 'स्लॉट',
    modal_delivering_to: 'डिलीवरी का पता',
    modal_payment_cod: 'कैश ऑन डिलीवरी (COD)',
    modal_payment_online: 'ऑनलाइन भुगतान सफल (Razorpay)',
    modal_zero_cash: 'डिलीवरी के समय नकद भुगतान की आवश्यकता नहीं है',
    modal_verified: '✓ सत्यापित',
    modal_track_order_btn: 'ऑर्डर लाइव ट्रैक करें',
    modal_continue_shopping_btn: 'और खरीदारी करें',
    modal_order_num_copied: 'कॉपी हो गया!',
    modal_auto_redirect: '{sec} सेकंड में लाइव ट्रैकर पर जा रहे हैं…',

    // Sign In / Auth
    auth_welcome_title: 'साइन इन / रजिस्टर',
    auth_welcome_subtitle: 'ताज़ी ग्रॉसरी कुछ ही मिनटों में सीधे आपके घर',
    auth_mode_password: 'पासवर्ड से लॉगिन',
    auth_mode_otp: 'OTP से लॉगिन',
    auth_mode_register: 'नया खाता बनाएं',
    auth_mode_forgot: 'पासवर्ड रीसेट करें',
    auth_phone_label: 'मोबाइल फोन नंबर',
    auth_phone_placeholder: '10 अंकों का मोबाइल नंबर',
    auth_password_label: 'पासवर्ड',
    auth_password_placeholder: 'अपना पासवर्ड दर्ज करें',
    auth_confirm_password_label: 'पासवर्ड की पुष्टि करें',
    auth_confirm_password_placeholder: 'दोबारा पासवर्ड दर्ज करें',
    auth_fullname_label: 'आपका नाम',
    auth_fullname_placeholder: 'पूरा नाम दर्ज करें (उदा. अमित कुमार)',
    auth_otp_label: '4 अंकों का OTP दर्ज करें',
    auth_otp_sent_to: 'हमने सत्यापन कोड भेजा है: {phone}',
    auth_send_otp_btn: 'सत्यापन कोड भेजें',
    auth_verify_btn: 'सत्यापित करें और साइन इन करें',
    auth_login_btn: 'साइन इन करें',
    auth_register_btn: 'खाता बनाएं और आगे बढ़ें',
    auth_reset_btn: 'पासवर्ड रीसेट करें',
    auth_resend_otp: 'OTP दोबारा भेजें',
    auth_resend_in: '{sec}s में दोबारा भेजें',
    auth_forgot_link: 'पासवर्ड भूल गए?',
    auth_back_to_login: 'लॉगिन पर वापस जाएं',
    auth_new_user: 'नए ग्राहक हैं?',
    auth_already_account: 'पहले से खाता है?',
    auth_terms_note: 'आगे बढ़कर आप हमारी सेवा की शर्तों और गोपनीयता नीति से सहमत होते हैं।',

    // Footer
    footer_about: 'सुपरफास्ट ताज़ी ग्रॉसरी, खेत से सीधे फल-सब्जियां और राशन सामग्री 15-25 मिनट में आपके दरवाज़े पर।',
    footer_hours: 'सुबह 7:00 – रात 11:00 बजे प्रतिदिन',
    footer_categories_title: 'ग्रॉसरी श्रेणियां',
    footer_customer_care: 'ग्राहक सेवा सहायता',
    footer_safe_certified: 'सुरक्षित और प्रमाणित',
    footer_cat_veg_fruit: 'ताज़ी सब्जियां और फल',
    footer_cat_dairy: 'दूध, ब्रेड और अंडे',
    footer_cat_staples: 'आटा, चावल और दालें',
    footer_cat_snacks: 'नमकीन और स्नैक्स',
    footer_care_track: 'ऑर्डर ट्रैकिंग व रसीद',
    footer_care_delivery: 'डिलीवरी संबंधी जानकारी',
    footer_care_returns: 'आसान 2 घंटे की रिटर्न नीति',
    footer_care_support: 'सहायता: care@freshgrocer.com',
    footer_cert_fssai: 'FSSAI प्रमाणित डार्क स्टोर्स',
    footer_cert_sanitized: 'संपर्क रहित और सैनिटाइज्ड डिलीवरी',
    footer_cert_gst: 'प्रामाणिक GST इनवॉइस',
    footer_copyright: '© {year} FreshGrocer Platform Ltd. सभी कीमतें GST सहित हैं।',
    footer_payments_accepted: 'Razorpay प्रमाणित • UPI और कार्ड स्वीकार्य • कैश ऑन डिलीवरी',

    // Checkout extra
    checkout_signin_title: 'चेकआउट के लिए साइन इन करें',
    checkout_signin_desc: 'सहेजे गए पते देखने, डिलीवरी स्लॉट चुनने और ऑर्डर ट्रैक करने के लिए कृपया अपने मोबाइल नंबर से साइन इन करें।',
    checkout_signin_btn: 'आगे बढ़ने के लिए साइन इन करें',
    checkout_step_how: 'आप ऑर्डर कैसे प्राप्त करना चाहते हैं?',
    checkout_home_delivery_desc: '15–25 मिनट में सीधे आपके घर',
    checkout_store_pickup_desc: 'दुकान से तैयार बैग प्राप्त करें',
    checkout_no_address: 'अभी तक कोई पता सहेजा नहीं है',
    checkout_no_address_desc: 'सुपरफास्ट डिलीवरी के लिए पता जोड़ें',
    checkout_add_address_now: '+ अभी पता जोड़ें',
    checkout_slot_step: 'डिलीवरी का समय (स्लॉट)',
    checkout_slot_date: 'डिलीवरी की तारीख',
    checkout_slot_auto: 'मानक एक्सप्रेस स्लॉट (15–25 मिनट) अपने आप असाइन किए जाएंगे।',
    checkout_payment_step: 'भुगतान का तरीका',
    checkout_online_subtitle: 'सुरक्षित रेज़रपे गेटवे, शून्य अतिरिक्त शुल्क',
    checkout_cod_subtitle: 'डिलीवरी मिलने पर नकद या UPI द्वारा भुगतान करें',
    checkout_otp_badge: 'डिलीवरी के समय 4 अंकों के कोड की पुष्टि आवश्यक है।',
    checkout_goods_subtotal: 'सामान का कुल मूल्य',
    checkout_coupon: 'कूपन',
    checkout_delivery_fee: 'डिलीवरी शुल्क',
    checkout_gst_included: 'GST सहित',
    checkout_grand_total: 'कुल देय राशि',
    checkout_guaranteed_price: 'अंतिम निश्चित बिल राशि',
    checkout_calculating: 'टैक्स और डिलीवरी शुल्क का हिसाब हो रहा है…',
    checkout_badge_secure: 'रेज़रपे सत्यापित और पक्का GST बिल शामिल',

    // Order Detail extra
    order_banner_title: 'आपका ऑर्डर कन्फर्म हो गया है और जल्द ही डिलीवर होगा!',
    order_banner_desc: 'Aapka order confirm ho gaya hai aur jaldi hi aapke doorstep par deliver hoga. Niche real-time status track karein.',
    order_banner_badge: 'ऑर्डर कन्फर्म हुआ',
    order_banner_packing: '⚡ पैकिंग शुरू हो गई है',
    order_items_ordered: 'ऑर्डर किए गए सामान ({count})',
    order_delivering_to: 'डिलीवरी का पता',
    order_tracking_timeline: 'ट्रैकिंग टाइमलाइन',
    order_payment_breakdown: 'भुगतान का विवरण',
    order_goods_subtotal: 'सामान का मूल्य',
    order_prod_discounts: 'उत्पाद छूट',
    order_delivery_fee: 'डिलीवरी शुल्क',
    order_gst_included: 'सामान पर GST शामिल',
    order_total_amount: 'कुल राशि',
    order_amount_paid: 'भुगतान की गई राशि',
    order_weighed_notice: 'पैकिंग के समय तौला गया: वास्तविक वजन के आधार पर मात्रा और बिल राशि समायोजित की गई है।',
    order_cancel_title: 'ऑर्डर रद्द करें',
    order_cancel_desc: 'प्राप्त (Received) स्थिति में रहने तक आप यह ऑर्डर रद्द कर सकते हैं।',
    order_cancel_reason_ph: 'रद्द करने का कारण (वैकल्पिक)',
    order_cancelling: 'रद्द किया जा रहा है…',
    order_pay_now_razorpay: 'Razorpay से {amount} भुगतान करें',
    order_pay_cash_instead: 'कैश ऑन डिलीवरी (COD) चुनें',
    order_prefer_cashless: 'कैशलेस भुगतान? Razorpay से ऑनलाइन पे करें',
    order_payment_pending: 'ऑनलाइन भुगतान बाकी है',
    order_payment_due_badge: 'भुगतान बाकी',
    order_pay_at_delivery_badge: 'डिलीवरी पर भुगतान करें',
    order_opening_razorpay: 'Razorpay खुल रहा है…',
    order_switching_cash: 'कैश पर स्विच किया जा रहा है…',
    order_cod_due_notice: 'आपका ऑर्डर कैश ऑन डिलीवरी पर है। कृपया डिलीवरी पार्टनर आने पर नकद तैयार रखें।',
  },
} as const

export type TranslationKey = keyof typeof translations.en
